var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site",attrs:{"id":"app","lang":_vm.$i18n.locale,"data-server-rendered":"true"}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }